/* global axios */

const userEventTypesAPI = {
  // Get all event types for current user
  getAll() {
    return axios.get('/api/v1/user_event_types');
  },

  // Create new event type
  create(data) {
    return axios.post('/api/v1/user_event_types', data);
  },

  // Delete event type
  delete(id) {
    return axios.delete(`/api/v1/user_event_types/${id}`);
  },

  // Fetch event details from Kivo Calendar (via backend)
  fetchEventDetails(eventId) {
    return axios.get('/api/v1/user_event_types/fetch_event_details', {
      params: { event_id: eventId },
    });
  },

  // Sync all event types from Kivo Calendar
  // Updates only existing events - does not add new ones
  sync() {
    return axios.post('/api/v1/user_event_types/sync');
  },

  // Get available slots for a month (via backend)
  getAvailabilitySlots({ eventId, scheduleId, month, year, timeZone, contactEmail }) {
    return axios.get('/api/v1/user_event_types/availability_slots', {
      params: {
        event_id: eventId,
        schedule_id: scheduleId,
        month,
        year,
        time_zone: timeZone,
        contact_email: contactEmail,
      },
    });
  },

  // Book an appointment (via backend)
  bookAppointment(data) {
    return axios.post('/api/v1/user_event_types/book_appointment', data);
  },
};

export default userEventTypesAPI;
